export const MOBILE_HOME_MAX_WIDTH = 768;

export function isMobileViewport(maxWidth = MOBILE_HOME_MAX_WIDTH) {
  if (typeof window === "undefined") return false;
  if (typeof window.matchMedia === "function") {
    return window.matchMedia(`(max-width:${maxWidth}px)`).matches;
  }
  return window.innerWidth <= maxWidth;
}

/** Default landing path: Dashboard. */
export function getDefaultHomePath() {
  return "/";
}
